/**
 * Add default values to the load mol params.
 *
 * @param {ILoadMolParams} params  The params to add defaults to.
 * @returns {ILoadMolParams}  The params with defaults added.
 */
export function addDefaultLoadMolParams(params) {
    return {
        addToTree: true,
        desalt: false,
        defaultTitle: "Molecule",
        hideOnLoad: false,
        mergeBondedCompounds: true,
        ...params,
    };
}
